import React from 'react'
import { Box } from '@material-ui/core';
import Navbar from '../../components/Navbar/Navbar';

function Profile() {
    return (
        <Box>
            <Navbar />

        </Box>
    )
}

export default Profile;